// extracted by mini-css-extract-plugin
module.exports = {"button":"radio-button-group_button__2kGWG","incorrect":"radio-button-group_incorrect__Ia-nM"};